import React, { useContext } from 'react';
import styled from 'styled-components';

import IconCheckbox from '../../misc/IconCheckbox';
import Icon from '../../misc/Icon';
import { StyledFieldLabel } from './SettingsCommonElements';

import ThemeContext from '../../../theme/ThemeContext';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledLabel = styled(StyledFieldLabel)`
  margin-right: 4px;
  margin-bottom: 0px !important;
  whitespace: normal;
  flex: 1;
`;

const StyledDescription = styled.div`
  font-size: 10px;
  color: ${(props) => props.theme.fontColorSecondary};
`;

const StyledIcon = styled.div`
  width: 18px;
  margin-right: 4px;
  text-align: center;
`;

const CheckboxSettingsField = ({
  id,
  icon,
  iconColor,
  iconSize,
  label,
  description,
  selected,
  onChange,
  disabled
}) => {

  const theme = useContext(ThemeContext);

  const iconNode = !icon ? null : (
    <StyledIcon>
      <Icon
        icon={icon}
        color={iconColor || theme.fontColorPrimary}
        size={iconSize || 'sm'}
      />
    </StyledIcon>
  );

  return (
    <>
      <StyledWrapper>
        {iconNode}
        <StyledLabel>{label}</StyledLabel>
        <IconCheckbox
          id={id}
          size="lg"
          disabled={disabled}
          selected={selected}
          onChange={onChange}
        />
      </StyledWrapper>
      {!description ? null : <StyledDescription theme={theme}>{description}</StyledDescription>}
    </>
  );

};

export default CheckboxSettingsField;
